export { PLUGIN_KEY, PLUGIN_PRIORITY, BindRowsWithHeaders } from "./bindRowsWithHeaders.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/bindRowsWithHeaders/index.mjs
// module id = 1246
// module chunks = 1